import React, {useEffect,useState} from "react";
import "./onSearch.css";
import youtubeapi from "../API/youtubeapi";




function OnSearch(param) {

    const[pageToken, setpageToken] = useState(param.pageToken);
    // console.log(param.searchedquery, param.pageToken);
    const[resdata,setresdata] = useState(null);

    useEffect(()=>{
        const data = youtubeapi.get('search', {
            params: {
            part: 'snippet',
            maxResults: 5,
            q: param.searchedquery,
            key: 'AIzaSyDyJEXZRvPJkm1zzgEroc-uXcBLuTAMCgY'
        }
        }).then(res => {
            param.handlepageToken(res.data.nextPageToken);
            setresdata(res.data.items);
            console.log(res);
        })   
    },[param.searchedquery]);
    
    
    
    // // Infinite scrolling is in this module
    // // when scroll reaches at bottom than new request is made using the below function
    const reachedBottom = ()=>{
        //console.log(param.pageToken);
        const data = youtubeapi.get('search', {
            params: {
            part: 'snippet',
            maxResults: 5,
            q: param.searchedquery,
            pageToken: param.pageToken,
            key: 'AIzaSyDyJEXZRvPJkm1zzgEroc-uXcBLuTAMCgY'
        }
        }).then(res => {
            param.handlepageToken(res.data.nextPageToken);
            setresdata([...resdata, ...res.data.items]);
        })
    }
    
    //const res = YtApiRes(param.searchedquery,pageToken);
    // console.log(res);
    // setpageToken(res.nextPageToken);


    //console.log(resdata);

    return(
        <div className="onSearch">
            <div className="filter">
                <div className="filter-btn">
                    <i className="fas fa-sliders-h"></i>
                    <p>FILTERS</p>
                </div>
            </div>
            {resdata?resdata.map(title =>
                { return <div className="video-cards" key={title.id.videoId}>
                    <br/>
                    <a href={`https://www.youtube.com/watch?v=${title.id.videoId}`}>
                        <img src={title.snippet.thumbnails.high.url} />
                        <div className="video-info">
                            <h4>{title.snippet.title}</h4>
                            <p>{title.snippet.publishTime}</p>
                            <br/>
                            <p>{title.snippet.channelTitle}</p>
                            <br/>
                            <p>{title.snippet.description}</p>
                        </div>
                    </a>
                </div>}):null}
            <button onClick={reachedBottom}>Bottom</button>
        </div>
    );
}

export default OnSearch;

